



































import { Vue, Component } from 'vue-property-decorator'
import { Button } from 'mand-mobile'

@Component({ components: {[Button.name]: Button} })
export default class Home extends Vue {
  $refs!: {
    inputImageEl: HTMLInputElement,
    imageEl: HTMLImageElement,
  }
  previewImage = false
  file: any = null
  compressedImageInfo: any = null

  startHandler() {
    this.$refs.inputImageEl.click()
  }
  get originImageSize() {
    return Math.round(this.file.size / 1024)
  }

  get compressedImageSize() {
    return Math.round(this.compressedImageInfo.size / 1024)
  }

  inputImgHandler() {
    const files = this.$refs.inputImageEl.files
    this.file = files ? files[0] : null
    // console.log('file', this.file)
    const imageInfo = this.$refs.imageEl
    imageInfo.src = window.URL.createObjectURL(this.file)
    // console.log('origin image src', imageInfo.src)
    this.previewImage = true
    this.compressImageHandler(imageInfo.src, this.originImageSize / 1024)
  }

  compressImageHandler(res: any, fileSize: number) {
    const img = new Image()
    const maxW = 1028
    img.onload = () => {
      const cvs = document.createElement('canvas')
      const ctx = cvs.getContext('2d')
      if (img.width > maxW) {
        img.height *= maxW / img.width
        img.width = maxW
      }
      cvs.width = img.width
      cvs.height = img.height

      if (!ctx) {
        return
      }
      ctx.clearRect(0, 0, cvs.width, cvs.height)
      ctx.drawImage(img, 0, 0, img.width, img.height)

      const compressRate = this.getCompressRate(1, fileSize)
      const dataUrl = cvs.toDataURL('image/jpeg', compressRate)
      document.body.appendChild(cvs)
      this.dataURLtoBlob(dataUrl)

      document.getElementsByTagName('canvas')[0].style.marginLeft = '15px'
      document.getElementsByTagName('canvas')[0].style.width = '300px'
    }
    img.src = res
    // console.log('compressed src', img.src)
  }

  getCompressRate(allowMaxSize: any, fileSize: number) {
    let compressRate = 1

    if (fileSize / allowMaxSize > 4) {
      compressRate = 0.5
    } else if (fileSize / allowMaxSize > 3) {
      compressRate = 0.6;
    } else if (fileSize / allowMaxSize > 2) {
      compressRate = 0.7
    } else if (fileSize > allowMaxSize) {
      compressRate = 0.8
    } else {
      compressRate = 0.9
    }
    return compressRate
  }

  dataURLtoBlob(dataUrl: any) {
    const arr = dataUrl.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while ( n-- ) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    this.compressedImageInfo = new Blob([u8arr], { type: mime })
    // console.log('compressed', new Blob([u8arr], { type: mime }))
    return new Blob([u8arr], {type: mime})
  }

  downloadHandler(image: any) {
    const a = document.createElement('a')
    const url = window.URL.createObjectURL(image)
    a.href = url
    a.download = image.name
    a.click()
    window.URL.revokeObjectURL(url)
  }
}
